/**
 * Different Breadcrumbs separators.
 * @public
 */
enum BreadcrumbsSeparator {

	/**
	 * The separator appears as "/".
	 * @public
	 */
	Slash = "Slash",

	/**
	 * The separator appears as "\".
	 * @public
	 */
	BackSlash = "BackSlash",

	/**
	 * The separator appears as "\\".
	 * @public
	 */
	DoubleBackSlash = "DoubleBackSlash",

	/**
	 * The separator appears as ">>".
	 * @public
	 */
	DoubleGreaterThan = "DoubleGreaterThan",

	/**
	 * The separator appears as "//" .
	 * @public
	 */
	DoubleSlash = "DoubleSlash",

	/**
	 * The separator appears as ">".
	 * @public
	 */
	GreaterThan = "GreaterThan",
}

export default BreadcrumbsSeparator;
